<template>
    <vue-select
        :value="value"
        @input="handleInput"
        v-if="options"
        v-bind="$attrs"
        v-on="$listeners"
        :options="filtered_options"
    >
        <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
                Hittade inga resultat på <em>{{ search }}</em>.
            </template>
            <em style="opacity: 0.5;" v-else>Sök på adress</em>
        </template>
    </vue-select>
</template>

<script>
import VueSelect from '@components/Wrappers/VueSelect';
import Cache from '@services/Cache';
import apiClient from '@services/ApiClient';

export default {
    name: 'SalaryTypeFilter',
    components: {
        VueSelect,
    },
    props: {
        value: null,
        filter: {
            type: Function,
            default(options) {
                return options;
            },
        },
    },
    data() {
        return {
            options: null,
        };
    },
    async created() {
        this.options = await this.getOptions();
    },
    methods: {
        handleInput(value) {
            this.$emit('input', value);
        },
        async getOptions() {
            let options = [];

            if (Cache.get('user-salary-types')) {
                options = Cache.get('user-salary-types');
            } else {
                await apiClient.get('/vue/users/salary_types')
                    .then((response) => {
                        options = response.data;
                        Cache.set('user-salary-types', response.data);
                    });
            }

            return options;
        },
    },
    computed: {
        filtered_options() {
            return this.filter(this.options);
        },
    },
};
</script>
